



























import { defineComponent } from '@vue/composition-api';

// primevue
import Textarea from 'primevue/textarea';
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
    components: {
        Textarea,
        ProgressSpinner,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup() {},
});
